(function () {
	const slideshow = () => {
		$(".slideshow-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".slideshow");
			const autoplay = box.data("autoplay");
			const isPrereview = box.data("is-prereview");
			const isLoop = box.data("loop");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			const slideCount = box.data("slide-count");
			const speed = box.data("speed") * 1000;

			document.documentElement.style.setProperty(
				"--bullet-duration",
				`${delay + speed}ms`
			);

			let autoplayParam;
			if (autoplay && slideCount > 1) {
				autoplayParam = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			} else {
				autoplayParam = {
					autoplay: false,
				};
			}

			const preriewParams = isPrereview
				? {
						//slidesPerView: 1.2,
						//centeredSlides: true,
				  }
				: {};

			const commonParams = {
				speed,
				effect: box.data("effect"),
				loop: isLoop && slideCount > 1,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				mousewheel: {
					forceToAxis: true,
				},
				...autoplayParam,
			};

			const swiperOverlayParams = {
				parallax: box.data("parallax"),
				centeredSlides: false,
				...preriewParams,
				spaceBetween: 0,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
				breakpoints: {
					1100: {
						spaceBetween: 32,
					},
				},
			};

			const changeColorScheme = (context) => {
				const activeIndex = context.activeIndex;
				const activeSlide = context.slides[activeIndex];
				const changeItems = [
					context.navigation.nextEl,
					context.navigation.prevEl,
					context.pagination.el,
				];

				const colorScheme = activeSlide?.dataset?.colorScheme;

				changeItems.forEach((item) => {
					if (item) {
						let classNames = item.getAttribute("class");
						classNames = classNames.replace(/color-background-\d+/g, "");
						item.setAttribute("class", classNames);
						item.classList.add(colorScheme);
					}
				});
			};

			const sliderEl = document.querySelector(`#${id} .slideshow__swiper`);

			const swiperOverlay = new Swiper(sliderEl, {
				...commonParams,
				...swiperOverlayParams,
			});

			if (isPrereview) {
				document.addEventListener("focusin", (e) => {
					if (
						e.target.closest(".slideshow__swiper.swiper.swiper-initialized")
					) {
						const slide = e.target.closest(".swiper-slide");
						if (!slide) return;
						const index = [...swiperOverlay.slides].indexOf(slide);
						if (swiperOverlay.activeIndex !== index) {
							swiperOverlay.slideTo(index, 0);
						}
					}
				});
			}

			changeColorScheme(swiperOverlay);
			swiperOverlay.on("beforeTransitionStart", function () {
				changeColorScheme(this);
			});

			function revealLineAnimation() {
				function initStaggeredLineReveal(element) {
					if (!element.querySelector(".staggered-line-reveal__word")) {
						const words = element.innerText.trim().split(" ");
						element.innerHTML = words
							.map(
								(word) =>
									`<span class="staggered-line-reveal__word">${word}</span>`
							)
							.join(" ");
					}

					element.style.visibility = "visible";
					element.setAttribute("style", "opacity: 1 !important;");

					const spans = Array.from(
						element.querySelectorAll(".staggered-line-reveal__word")
					);

					const lines = [];
					let currentLineTop = null;
					let currentLine = [];

					spans.forEach((span) => {
						const top = span.offsetTop;
						if (currentLineTop === null) currentLineTop = top;

						if (top === currentLineTop) {
							currentLine.push(span);
						} else {
							lines.push(currentLine);
							currentLine = [span];
							currentLineTop = top;
						}
					});

					if (currentLine.length) lines.push(currentLine);

					lines.forEach((line, i) => {
						setTimeout(() => {
							line.forEach((span) => span.classList.add("show"));
						}, i * 300);
					});
				}

				document.querySelectorAll(".staggered-line-reveal").forEach((el) => {
					const observer = new IntersectionObserver(
						(entries, obs) => {
							entries.forEach((entry) => {
								if (entry.isIntersecting) {
									initStaggeredLineReveal(entry.target);
									obs.unobserve(entry.target);
								}
							});
						},
						{ threshold: 0.6 }
					);
					observer.observe(el);
				});
			}

			revealLineAnimation();

			swiperOverlay.on("slideChange", function () {
				setTimeout(() => {
					document
						.querySelectorAll(
							".swiper-slide:not(.swiper-slide-active) .staggered-line-reveal__word"
						)
						.forEach((el) => el.classList.remove("show"));
				}, 900);

				revealLineAnimation();

				const activeIndex = this.activeIndex;
				const activeSlide = this.slides[activeIndex];
				initButtonsAnimation(activeSlide);
			});
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
	});
})();
